import React from "react";
import TabSectionHeader from '../Elements/TabSectionHeader';
import { LINKED_IN_RECOMMENDATIONS_LINK } from "../utils/constants";

import recommendation1 from "../assets/Images/recommendation1.png";
import recommendation2 from "../assets/Images/recommendation2.png";
import recommendation3 from "../assets/Images/recommendation3.png";
import recommendation4 from "../assets/Images/recommendation4.png";
import recommendation5 from "../assets/Images/recommendation5.png";

const LINKED_IN_RECCOMENDATION_IMAGES = [
  recommendation1,
  recommendation2,
  recommendation3,
  recommendation4,
  recommendation5,
];

const LinkedInRecommendations = () => {
  return (
    <section className="h-full min-h-0 flex flex-col bg-transparent text-ink">
      <TabSectionHeader tabIndex={4} />
      <div className="flex-1 min-h-0 flex flex-col max-w-4xl mx-auto w-full text-center">
        <div className="flex-1 min-h-0 overflow-y-auto custom-scrollbar py-2">
          {LINKED_IN_RECCOMENDATION_IMAGES.map((recommendationImg) => (
            <img
              key={recommendationImg}
              src={recommendationImg}
              alt="recommendation"
              className="w-full mb-4"
            />
          ))}
        </div>
        <a
          href={LINKED_IN_RECOMMENDATIONS_LINK}
          target="_blank"
          rel="noreferrer"
          className="text-accent underline mt-4 block shrink-0"
        >
          View all recommendations on LinkedIn
        </a>
      </div>
    </section>
  );
};

export default LinkedInRecommendations;
